/** Bump when the AI terms materially change to re-prompt existing users. */
export const AI_TERMS_VERSION = 1;

/** One-time free AI token gift offered during Nexus AI onboarding (per business). */
export const AI_WELCOME_TOKENS = 1_000_000;
